import styled from "styled-components";
import theme from "../theme";
import { IconUser } from "../icons";

const Wrapper = styled.div`
  background: ${theme.bg};
  border-radius: 8px;
  border: 1.5px solid ${theme.cardBorder};
  padding: 12px 16px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
`;

const Avatar = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1.5px solid ${theme.cardBorder};
  background: ${theme.cardBg};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.textMuted};
  flex-shrink: 0;
  overflow: hidden;
`;

const AvatarImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Username = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${theme.textSub};
`;

const Timestamp = styled.span`
  font-size: 11.5px;
  color: ${theme.textMuted};
`;

const Text = styled.p`
  font-size: 13.5px;
  color: ${theme.textMain};
  margin: 0;
  line-height: 1.55;
`;

function formatDate(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

export default function Comment({ comment }) {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const avatarSrc =
    comment.userId?.profilePicture
      ? `${BASE_URL?.replace("/api", "")}/images/${comment.userId.profilePicture}`
      : null;

  const username = comment.userId?.username || "User";

  return (
    <Wrapper>
      <Avatar>
        {avatarSrc ? (
          <AvatarImg src={avatarSrc} alt={username} />
        ) : (
          <IconUser size="16px" />
        )}
      </Avatar>
      <Content>
        <Header>
          <Username>{username}</Username>
          <Timestamp>{formatDate(comment.createdAt)}</Timestamp>
        </Header>
        <Text>{comment.text}</Text>
      </Content>
    </Wrapper>
  );
}
